// Compose a human-readable track description from the wizard's structured inputs.
// Shared by the autosave path (BuildTrack) and the finalize payload (Review) so the saved
// draft and the published track describe the track the same way.
export function composeDescription(blocks, dna) {
    const parts = []
    if (blocks.audience) parts.push(`For ${blocks.audience}.`)
    if (dna.transformationStatement) parts.push(dna.transformationStatement)
    else if (blocks.outcome) parts.push(blocks.outcome)
    if (blocks.challenge) parts.push(`This track addresses a key challenge: ${blocks.challenge}`)
    return parts.join("\n\n") || "An AI-assisted mentorship track."
}
